export default __webpack_public_path__ + "static/media/cross.69f9b8e8.svg";